import { normalizePath } from './normalizePath';
const NAMESPACE = 'Business Units Lib';
const EVENT_NAME = 'Select Changed';
const DEFAULT_BRAND_SAVED_EVENT_NAME = 'Default Brand Saved';
export function createBusinessUnitSelectChangeTracker(trackerInstance) {
  const newTracker = trackerInstance.clone({
    standalone: true,
    preserveTrackerEvents: false,
    preserveTrackerProperties: false
  });
  return properties => {
    newTracker.track(NAMESPACE, EVENT_NAME, Object.assign({}, properties, {
      path: normalizePath(window.location.pathname)
    }));
  };
}
export function createDefaultBrandSavedTracker(trackerInstance) {
  const newTracker = trackerInstance.clone({
    standalone: true,
    preserveTrackerEvents: false,
    preserveTrackerProperties: false
  });
  return () => {
    newTracker.track(NAMESPACE, DEFAULT_BRAND_SAVED_EVENT_NAME, {
      screen: normalizePath(window.location.pathname)
    });
  };
}